export const InitialEntry = {
  date: new Date(),
  text: "",
};
